import { c as _c } from "react/compiler-runtime";
import { useEventCallback } from './useEventCallback';
export function useCombinedEventCallbacks(...t0) {
  const $ = _c(2);
  const callbacks = t0;
  let t1;
  if ($[0] !== callbacks) {
    t1 = (...t2) => {
      const args = t2;
      for (const callback of callbacks) {
        callback(...args);
      }
    };
    $[0] = callbacks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useEventCallback(t1);
}